import React from 'react';
import { Link } from 'react-router-dom';
import { BrainIcon, SparklesIcon, TargetIcon, TrendingUpIcon, ZapIcon, CheckCircleIcon, ArrowRightIcon, UsersIcon, MessageSquareIcon, ClockIcon } from 'lucide-react';
export function CopilotPage() {
  return <div className="w-full bg-white" data-id="element-6518">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-purple-900 text-white py-24 overflow-hidden" data-id="element-6519">
        <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:20px_20px]" data-id="element-6520" />
        <div className="absolute inset-0" data-id="element-6521">
          <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500/20 rounded-full blur-3xl animate-pulse" data-id="element-6522" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-6523" />
        </div>
        <div className="max-w-7xl mx-auto px-6 relative" data-id="element-6524">
          <div className="max-w-4xl mx-auto text-center" data-id="element-6525">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/20 rounded-full border border-blue-400/30 mb-6" data-id="element-6526">
              <SparklesIcon className="w-4 h-4" data-id="element-6527" />
              <span className="text-sm font-medium" data-id="element-6528">
                AI-Powered GTM Assistant
              </span>
            </div>
            <h1 className="text-6xl font-bold mb-6 leading-tight" data-id="element-6529">
              ZoomInfo Copilot
            </h1>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed" data-id="element-6530">
              AI that tells sellers and CS reps which accounts to work, who to
              contact, and what to say — all using real ZoomInfo data, not
              generic prompts.
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-6531">
              <Link to="/signup" className="px-8 py-4 bg-white text-blue-900 rounded-lg hover:bg-blue-50 font-medium text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-6532">
                Try Copilot Free
              </Link>
              <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-6533">
                Schedule Demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* What Copilot Does */}
      <section className="py-24 bg-white" data-id="element-6534">
        <div className="max-w-7xl mx-auto px-6" data-id="element-6535">
          <div className="text-center mb-16" data-id="element-6536">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6537">
              What Copilot does
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-6538">
              Copilot sits inside your workflow and guides reps through every
              GTM motion with context-aware suggestions.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-6539">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 border-2 border-blue-200" data-id="element-6540">
              <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center mb-6" data-id="element-6541">
                <TargetIcon className="w-8 h-8 text-white" data-id="element-6542" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-6543">
                Prioritizes accounts
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-6544">
                Shows reps which accounts to work today based on intent, buying
                groups, and play eligibility. No more guessing.
              </p>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-8 border-2 border-purple-200" data-id="element-6545">
              <div className="w-16 h-16 bg-purple-600 rounded-xl flex items-center justify-center mb-6" data-id="element-6546">
                <UsersIcon className="w-8 h-8 text-white" data-id="element-6547" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-6548">
                Suggests contacts
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-6549">
                Recommends which buying group members to reach, with real-time
                org charts and role detection.
              </p>
            </div>
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-8 border-2 border-green-200" data-id="element-6550">
              <div className="w-16 h-16 bg-green-600 rounded-xl flex items-center justify-center mb-6" data-id="element-6551">
                <MessageSquareIcon className="w-8 h-8 text-white" data-id="element-6552" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-6553">
                Generates outreach
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-6554">
                Drafts emails, LinkedIn messages, and call scripts using account
                signals, not boilerplate templates.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Key Features */}
      <section className="py-24 bg-gray-50" data-id="element-6555">
        <div className="max-w-7xl mx-auto px-6" data-id="element-6556">
          <div className="text-center mb-16" data-id="element-6557">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6558">
              Built for real GTM workflows
            </h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-6559">
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6560">
              <div className="flex items-center gap-3 mb-4" data-id="element-6561">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-6562">
                  <BrainIcon className="w-6 h-6 text-white" data-id="element-6563" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-6564">
                  Account summaries
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6565">
                Instant briefings on company fit, recent signals, buying group
                status, and open opportunities. No manual research.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-6566">
                <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm" data-id="element-6567">
                  Intent signals
                </span>
                <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm" data-id="element-6568">
                  Org changes
                </span>
                <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm" data-id="element-6569">
                  Tech stack
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6570">
              <div className="flex items-center gap-3 mb-4" data-id="element-6571">
                <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center" data-id="element-6572">
                  <SparklesIcon className="w-6 h-6 text-white" data-id="element-6573" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-6574">
                  AI email drafts
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6575">
                Generate personalized emails using account context, persona pain
                points, and recent activity. Reps edit and send.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-6576">
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-6577">
                  Context-aware
                </span>
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-6578">
                  Persona-specific
                </span>
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-6579">
                  Signal-based
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6580">
              <div className="flex items-center gap-3 mb-4" data-id="element-6581">
                <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center" data-id="element-6582">
                  <TargetIcon className="w-6 h-6 text-white" data-id="element-6583" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-6584">
                  Play recommendations
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6585">
                Copilot suggests which plays to run based on account signals and
                eligibility. One click to launch.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-6586">
                <span className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm" data-id="element-6587">
                  Auto-eligibility
                </span>
                <span className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm" data-id="element-6588">
                  Signal triggers
                </span>
                <span className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm" data-id="element-6589">
                  One-click launch
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6590">
              <div className="flex items-center gap-3 mb-4" data-id="element-6591">
                <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center" data-id="element-6592">
                  <ClockIcon className="w-6 h-6 text-white" data-id="element-6593" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-6594">
                  Next best actions
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6595">
                Daily task list prioritized by urgency, account value, and
                signal strength. Reps always know what to do next.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-6596">
                <span className="px-3 py-1 bg-orange-50 text-orange-700 rounded-full text-sm" data-id="element-6597">
                  Prioritized
                </span>
                <span className="px-3 py-1 bg-orange-50 text-orange-700 rounded-full text-sm" data-id="element-6598">
                  Time-sensitive
                </span>
                <span className="px-3 py-1 bg-orange-50 text-orange-700 rounded-full text-sm" data-id="element-6599">
                  Value-ranked
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Why It Works */}
      <section className="py-24 bg-white" data-id="element-6600">
        <div className="max-w-7xl mx-auto px-6" data-id="element-6601">
          <div className="text-center mb-16" data-id="element-6602">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6603">
              Why Copilot works better than generic AI
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-6604">
            <div className="p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border border-gray-200" data-id="element-6605">
              <div className="flex items-start gap-4" data-id="element-6606">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-6607" />
                <div data-id="element-6608">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-6609">
                    Uses real ZoomInfo data
                  </h3>
                  <p className="text-gray-700" data-id="element-6610">
                    Not hallucinated facts. Copilot pulls from intent,
                    technographics, org charts, and buying groups.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border border-gray-200" data-id="element-6611">
              <div className="flex items-start gap-4" data-id="element-6612">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-6613" />
                <div data-id="element-6614">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-6615">
                    Tied to active plays
                  </h3>
                  <p className="text-gray-700" data-id="element-6616">
                    Recommendations align with the plays you built in Studio.
                    Not random suggestions.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border border-gray-200" data-id="element-6617">
              <div className="flex items-start gap-4" data-id="element-6618">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-6619" />
                <div data-id="element-6620">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-6621">
                    Learns from your CRM
                  </h3>
                  <p className="text-gray-700" data-id="element-6622">
                    Copilot sees deal stages, ownership, and history. It knows
                    what worked before.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border border-gray-200" data-id="element-6623">
              <div className="flex items-start gap-4" data-id="element-6624">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-6625" />
                <div data-id="element-6626">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-6627">
                    Respects guardrails
                  </h3>
                  <p className="text-gray-700" data-id="element-6628">
                    Frequency caps, compliance rules, and exclusions are
                    enforced automatically.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Use Cases */}
      <section className="py-24 bg-gray-50" data-id="element-6629">
        <div className="max-w-7xl mx-auto px-6" data-id="element-6630">
          <div className="text-center mb-16" data-id="element-6631">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6632">
              Who uses Copilot
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6633">
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all" data-id="element-6634">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-6635">
                SDRs and BDRs
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-6636">
                For prospecting high-intent accounts and booking more meetings
                with less research time.
              </p>
              <div className="text-sm text-gray-600" data-id="element-6637">
                <span className="font-medium" data-id="element-6638">Common tasks:</span> Account
                prioritization, email drafting, play execution
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all" data-id="element-6639">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-6640">
                Account Executives
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-6641">
                For multi-threading deals, identifying missing buying group
                roles, and accelerating pipeline.
              </p>
              <div className="text-sm text-gray-600" data-id="element-6642">
                <span className="font-medium" data-id="element-6643">Common tasks:</span> Buying group
                completion, deal acceleration, competitive intel
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all" data-id="element-6644">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-6645">
                Customer Success
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-6646">
                For expansion plays, renewal risk detection, and champion
                activation across the customer base.
              </p>
              <div className="text-sm text-gray-600" data-id="element-6647">
                <span className="font-medium" data-id="element-6648">Common tasks:</span> Expansion
                triggers, risk alerts, usage insights
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-blue-600 to-purple-700 text-white" data-id="element-6649">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-6650">
          <h2 className="text-4xl font-bold mb-6" data-id="element-6651">
            Ready to give your team AI-powered guidance?
          </h2>
          <p className="text-xl text-blue-100 mb-8" data-id="element-6652">
            Start using Copilot today with real ZoomInfo data
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-6653">
            <Link to="/signup" className="px-8 py-4 bg-white text-blue-600 rounded-lg hover:bg-blue-50 font-medium text-lg shadow-lg" data-id="element-6654">
              Try Free
            </Link>
            <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-6655">
              Talk to Sales
            </Link>
          </div>
        </div>
      </section>
    </div>;
}